import { redirect } from '@tanstack/react-router'

import { authLoaders } from '@/modules/auth'

export const routeOptions = {
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    preview: search.preview === '1' || search.preview === true || undefined,
  }),
  beforeLoad: async ({
    search,
  }: {
    search: { redirect?: string; preview?: boolean }
  }) => {
    if (search.preview) return
    const session = await authLoaders().getSession()
    if (session) throw redirect({ to: search.redirect ?? '/' })
  },
}

// Keeps the page the user asked for, so an email link still lands there after sign-in.
export const requireSession = async ({
  location,
}: {
  location: { pathname: string }
}) => {
  const session = await authLoaders().getSession()
  if (!session) {
    throw redirect({ to: '/login', search: { redirect: location.pathname } })
  }
}
